import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import { Box, Typography } from "@mui/material";
// import BollywoodCasinoimg from '../../../images/BollywoodCasino/bollywood casino.png'
// import FooterLinks from '../FooterLinks';
import { useLocation, useNavigate } from "react-router-dom";
import AAAGame from "./AAAGame";
import { useSelector } from "react-redux";
import FlipClock from "../../FlipClock/FlipClock";
import FooterLinks from "../FooterLinks";
import useRoundLoader from "../../../api/useRoundLoader";

import useCasinoBetplace from "../../../api/useCasinoBetplace";

const positions = ["", ""];

const mainRows = [
  { label: "A. Amar", values: ["2.12", "2.22"], betType: "Amar" },
  { label: "B. Akbar", values: ["3.15", "3.35"], betType: "Akbar" },
  { label: "C. Anthony", values: ["4.15", "4.45"], betType: "Anthony" },
];

const playCardValues = [
  { value: "A", betType: "CARD_A" },
  { value: "2", betType: "CARD_2" },
  { value: "3", betType: "CARD_3" },
  { value: "4", betType: "CARD_4" },
  { value: "5", betType: "CARD_5" },
  { value: "6", betType: "CARD_6" },
  { value: "7", betType: "CARD_7" },
  { value: "8", betType: "CARD_8" },
  { value: "9", betType: "CARD_9" },
  { value: "10", betType: "CARD_10" },
  { value: "J", betType: "CARD_J" },
  { value: "Q", betType: "CARD_Q" },
  { value: "K", betType: "CARD_K" },
];

const bettingOptions = [
  {
    label: "Even",
    odds: "2.12",
    betType: "even",
  },
  {
    label: "Odd",
    odds: "1.83",
    betType: "odd",
  },
  {
    odds: "1.97",
    betType: "red",
    label: (
      <Box display="flex" justifyContent="center" gap={1}>
        <Box className={styles.iconWrapper}>
          <svg
            key="hearts-small"
            className={styles.iconSmall}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14.7305 1.44C13.0378 -0.48 10.3174 -0.48 8.62468 1.44L8 2.14857L7.37531 1.44C5.68262 -0.48 2.96222 -0.48 1.26952 1.44C-0.423174 3.36 -0.423174 6.44571 1.26952 8.36571L8 16L14.7305 8.36571C16.4232 6.44571 16.4232 3.33714 14.7305 1.44Z"
              fill="url(#paint0_linear_7166_23565)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23565"
                x1="3.10791"
                y1="-0.661257"
                x2="14.1232"
                y2="9.04996"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            key="hearts-large"
            className={styles.iconLarge}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M22.4277 2.49398C19.8887 -0.386016 15.8081 -0.386016 13.2691 2.49398L12.332 3.55684L11.395 2.49398C8.85596 -0.386016 4.77536 -0.386016 2.23631 2.49398C-0.302729 5.37398 -0.302729 10.0026 2.23631 12.8826L12.332 24.334L22.4277 12.8826C24.9668 10.0026 24.9668 5.3397 22.4277 2.49398Z"
              fill="url(#paint0_linear_7166_23337)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23337"
                x1="4.99389"
                y1="-0.657901"
                x2="21.5168"
                y2="13.9089"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
        <Box className={styles.iconWrapper}>
          <svg
            key="diamonds-small"
            className={styles.iconSmall}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M16 8L8 16L0 8L8 0L16 8Z"
              fill="url(#paint0_linear_7166_23566)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23566"
                x1="3.336"
                y1="3.99543"
                x2="11.2419"
                y2="13.219"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            key="diamonds-large"
            className={styles.iconLarge}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M24.332 12.334L12.332 24.334L0.332031 12.334L12.332 0.333984L24.332 12.334Z"
              fill="url(#paint0_linear_7166_23338)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23338"
                x1="5.33603"
                y1="6.32713"
                x2="17.1949"
                y2="20.1624"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FE5B42" />
                <stop offset="1" stop-color="#BA0000" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
      </Box>
    ),
  },
  {
    odds: "1.97",
    betType: "black",
    label: (
      <Box display="flex" justifyContent="center" gap={1}>
        <Box className={styles.iconWrapper}>
          <svg
            key="clubs-small"
            className={styles.iconSmall}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M12.0167 5.77483C11.8053 5.77483 11.605 5.79603 11.4159 5.81722C11.7942 5.23444 12.0167 4.5457 12.0167 3.81457C12.0167 1.70596 10.2253 0 8.01113 0C5.79694 0 4.00556 1.70596 4.00556 3.81457C4.00556 4.55629 4.22809 5.23444 4.6064 5.81722C4.40612 5.78543 4.20584 5.77483 4.00556 5.77483C1.79138 5.77483 0 7.48079 0 9.5894C0 11.698 1.79138 13.404 4.00556 13.404C5.363 13.404 6.55355 12.7576 7.27677 11.7828C7.32128 13.5417 6.7427 14.9298 5.61892 16H10.3811C9.26843 14.9298 8.68985 13.5417 8.72323 11.7828C9.44645 12.7576 10.637 13.404 11.9944 13.404C14.2086 13.404 16 11.698 16 9.5894C16 7.48079 14.2198 5.77483 12.0167 5.77483Z"
              fill="url(#paint0_linear_7166_23570)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23570"
                x1="2.66737"
                y1="3.51682"
                x2="12.8332"
                y2="14.1928"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            key="clubs-large"
            className={styles.iconLarge}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M18.3571 8.99624C18.04 8.99624 17.7395 9.02802 17.4558 9.05981C18.0233 8.18564 18.3571 7.15253 18.3571 6.05584C18.3571 2.89293 15.67 0.333984 12.3487 0.333984C9.02744 0.333984 6.34038 2.89293 6.34038 6.05584C6.34038 7.16842 6.67417 8.18564 7.24163 9.05981C6.94121 9.01213 6.64079 8.99624 6.34038 8.99624C3.0191 8.99624 0.332031 11.5552 0.332031 14.7181C0.332031 17.881 3.0191 20.4399 6.34038 20.4399C8.37654 20.4399 10.1624 19.4704 11.2472 18.0082C11.314 20.6466 10.4461 22.7287 8.7604 24.334H15.9037C14.2347 22.7287 13.3668 20.6466 13.4169 18.0082C14.5017 19.4704 16.2875 20.4399 18.3237 20.4399C21.645 20.4399 24.332 17.881 24.332 14.7181C24.332 11.5552 21.6617 8.99624 18.3571 8.99624Z"
              fill="url(#paint0_linear_7166_23342)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23342"
                x1="4.33309"
                y1="5.60922"
                x2="19.5818"
                y2="21.6231"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
        <Box className={styles.iconWrapper}>
          <svg
            key="spades-small"
            className={styles.iconSmall}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14.7396 6.4L8.0015 0L1.26339 6.4C-0.421131 8 -0.421131 10.6057 1.26339 12.2057C2.92385 13.7829 5.57097 13.8057 7.25549 12.2971C7.1833 13.8286 6.60575 15.04 5.59503 16H10.3839C9.37318 15.04 8.79563 13.8057 8.72343 12.2971C10.408 13.8057 13.0791 13.7829 14.7155 12.2057C16.4241 10.5829 16.4241 8 14.7396 6.4Z"
              fill="url(#paint0_linear_7166_23571)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23571"
                x1="3.10819"
                y1="4.64503"
                x2="12.397"
                y2="14.4222"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            key="spades-large"
            className={styles.iconLarge}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M22.4414 9.93398L12.3343 0.333984L2.22712 9.93398C-0.299666 12.334 -0.299666 16.2426 2.22712 18.6426C4.71781 21.0083 8.68848 21.0426 11.2153 18.7797C11.107 21.0768 10.2406 22.894 8.72458 24.334H15.9079C14.3918 22.894 13.5255 21.0426 13.4172 18.7797C15.944 21.0426 19.9507 21.0083 22.4053 18.6426C24.9682 16.2083 24.9682 12.334 22.4414 9.93398Z"
              fill="url(#paint0_linear_7166_23343)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_7166_23343"
                x1="4.99432"
                y1="7.30153"
                x2="18.9276"
                y2="21.9672"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#454545" />
                <stop offset="1" />
              </linearGradient>
            </defs>
          </svg>
        </Box>
      </Box>
    ),
  },
  {
    label: "Under 7",
    odds: "2",
    betType: "under_7",
  },
  {
    label: "Over 7",
    odds: "2",
    betType: "over_7",
  },
];
function AmarAkbarAnthony({
  onBetSelect,
  locked,
  socketData,
  settledData,
  gameId = 11,
  hookExposureData,
}) {
  const roundId = socketData?.roundId;

  const [exposureData, setExposureData] = useState(null);

  useEffect(() => {
    if (hookExposureData === null) {
      setExposureData(null);
      return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
      setExposureData(hookExposureData);
    }
  }, [hookExposureData, gameId]);
  useEffect(() => {
    if (roundId) {
      setExposureData(null);
    }
  }, [roundId]);

  useEffect(() => {
    if (roundId) setExposureData(null);
  }, [roundId]);
  const getExposureValue = (key) => {
    if (!exposureData) return null;
    const keyMap = {
      AMAR: "ifAmarWins",
      AKBAR: "ifAkbarWins",
      ANTHONY: "ifAnthonyWins",
      EVEN: "ifEven",
      ODD: "ifOdd",
      RED: "ifRed",
      BLACK: "ifBlack",
      UNDER_7: "ifUnder7",
      OVER_7: "ifOver7",
      CARD_A: "ifCardA",
      CARD_2: "ifCard2",
      CARD_3: "ifCard3",
      CARD_4: "ifCard4",
      CARD_5: "ifCard5",
      CARD_6: "ifCard6",
      CARD_7: "ifCard7",
      CARD_8: "ifCard8",
      CARD_9: "ifCard9",
      CARD_10: "ifCard10",
      CARD_J: "ifCardJ",
      CARD_Q: "ifCardQ",
      CARD_K: "ifCardK",
    };
    const val = exposureData[keyMap[key] ?? key];
    if (val === undefined || val === 0) return null;
    return val;
  };
  const ExposureLabel = ({ value, small, align = "center", outside }) => {
    if (value === null || value === undefined || value === 0) return null;

    return (
      <Typography
        sx={{
          position: "absolute",
          left: align === "left" ? "8px" : "50%",
          transform: align === "left" ? "none" : "translateX(-50%)",
          bottom: small || outside ? "-14px" : "6px",
          fontSize: small ? "9px" : "11.5px",
          fontWeight: 700,
          color: value < 0 ? "#ff4444" : "#00ff88",
          textAlign: align === "left" ? "left" : "center",
          whiteSpace: "nowrap",
          zIndex: 10,
          lineHeight: 1,
        }}
      >
        {value > 0 ? `${value}` : value}
      </Typography>
    );
  };

  // Format betType for gameId 10 (or others)
  const formatBetType = (rawBetType) => {
    if (!rawBetType) return "";
    if (gameId !== 11) return rawBetType.toUpperCase();

    const betTypeMap = {
      Amar: "AMAR_BACK",
      Akbar: "AKBAR_BACK",
      Anthony: "ANTHONY_BACK",
      Amar: "AMAR_LAY",
      Akbar: "AKBAR_LAY",
      Anthony: "ANTHONY_LAY",
      even: "EVEN",
      odd: "ODD",
      red: "RED",
      black: "BLACK",
      under_7: "UNDER_7",
      over_7: "OVER_7",
      Ace: "A",
      R2: "R2",
      R3: "R3",
      R4: "R4",
      R5: "R5",
      R6: "R6",
      R7: "R7",
      R8: "R8",
      R9: "R9",
      R10: "R10",
      J: "J",
      Q: "Q",
      K: "K",
    };

    return betTypeMap[rawBetType.toLowerCase()] || rawBetType.toUpperCase();
  };
  // Local animation/countdown and bet dialog states are no longer needed here

  const isAuthenticated = useSelector((state) => state.auth.authenticated);

  // console.log(socketData,'betting socket')
  // console.log(settledData,'settled socket')

  //////////////////////

  // const { socketData, connected } = useGameSocket(11); // game id 11

  // useEffect(() => {
  //     if (socketData) {
  //         //   console.log('Time:', socketData.secondsRemaining);
  //         //    console.log('Time:', socketData.roundId);
  //         //   console.log('Animation Started (bettingClosed):', socketData.bettingClosed);
  //         setLocked(socketData.bettingClosed === true);
  //     }
  // }, [socketData]);

  /////////////////////

  // Countdown and animation are driven by socketData in parent/child components

  const handleNumberBoxClick = (
    value,
    label,
    positionIndex,
    buttonType,
    rawBetType,
  ) => {
    if (!locked) {
      const base = rawBetType.toUpperCase(); // 'AMAR' | 'AKBAR' | 'ANTHONY'
      const betType = buttonType === "RedButton" ? "LAY" : "BACK";

      const betData = {
        label: `${label} (${positions[positionIndex]})`,
        odds: parseFloat(value),
        position: positions[positionIndex],
        buttonType,
        betType,
        selection: rawBetType.toUpperCase(),
      };

      if (onBetSelect) onBetSelect(betData);
    }
  };

  const handleCardClick = (cardValue, cardBetType) => {
    if (!locked) {
      const bet = {
        label: cardValue,
        odds: 12,
        betType: "SIDE",
        selection: cardBetType,
        cardGuess: cardBetType,
      };
      if (onBetSelect) onBetSelect(bet);
    }
  };

  // const handleBetOptionClick = (option) => {
  //     if (!locked) {
  //         const bet = {
  //             label: option.label,
  //             odds: parseFloat(option.odds),
  //         };
  //         setSelectedBet(bet);
  //         setBetDialogOpen(true);
  //         if (onBetSelect) {
  //             onBetSelect(bet);
  //         }
  //     }
  // };

  const navigate = useNavigate();
  const handleBetOptionClick = (option) => {
    if (locked) return;
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }

    const bet = {
      label: option.label,
      odds: parseFloat(option.odds),
      betType: "SIDE",
      selection: option.betType.toUpperCase(),
    };
    if (onBetSelect) onBetSelect(bet);
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Box className={styles.MatchScreen_container}>
      <Box className={styles.box}>
        <Box sx={{ position: "relative", width: "100%" }}>
          <AAAGame
            bettingClosed={socketData?.bettingClosed === true}
            animationTime={
              typeof socketData?.animationTime === "number"
                ? socketData.animationTime
                : undefined
            }
            socketData={socketData}
            remainingTime={socketData?.remainingTime}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: "8px",
              right: "8px",
              zIndex: 10,
            }}
          >
            <FlipClock
              time={
                socketData?.bettingClosed ? 0 : socketData?.remainingTime 
              }
            />
          </Box>
        </Box>

        <Box className={styles.box1}>
          <Box className={styles.box3}>
            {mainRows.map((row, rowIdx) => (
              <Box key={row.label} className={styles.CardBox}>
                {/* Label + Exposure */}
                <Box
                  className={styles.FontBox}
                  sx={{
                    position: "relative",
                    padding: "8px 8px 22px 8px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    flex: 1,
                    minHeight: "12px",
                  }}
                >
                  <Typography className={styles.CardText}>
                    {row.label}
                  </Typography>
                  <ExposureLabel
                    value={getExposureValue(row.betType.toUpperCase())}
                    align="left"
                  />
                </Box>

                {/* Blue & Red Buttons */}
                {row.values.map((val, i) => (
                  <Box
                    key={i}
                    className={i === 0 ? styles.BlueButton : styles.RedButton}
                    onClick={() =>
                      handleNumberBoxClick(
                        val,
                        row.label,
                        i,
                        i === 0 ? "BlueButton" : "RedButton",
                        row.betType,
                      )
                    }
                    sx={{
                      cursor: locked ? "not-allowed" : "pointer",
                      position: "relative",
                    }}
                  >
                    <Typography className={styles.NumberText}>{val}</Typography>

                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <Box className={styles.box4}>
        <Box className={styles.box5}>
          {bettingOptions.reduce((acc, option, index) => {
            if (index % 2 === 0) {
              acc.push(
                <Box key={index} className={styles.EvenOddBox}>
                  <Typography className={styles.EvenOddText}>
                    {option.odds}
                  </Typography>
                  <Box
                    className={styles.EvenOddButton}
                    onClick={() => handleBetOptionClick(option)}
                    sx={{
                      cursor: locked ? "not-allowed" : "pointer",
                      position: "relative",
                    }}
                  >
                    <Typography className={styles.ButtonText}>
                      {option.label}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(option.betType.toUpperCase())}
                      outside
                    />

                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>

                  {bettingOptions[index + 1] && (
                    <>
                      <Typography className={styles.EvenOddText}>
                        {bettingOptions[index + 1].odds}
                      </Typography>
                      <Box
                        className={styles.EvenOddButton}
                        onClick={() =>
                          handleBetOptionClick(bettingOptions[index + 1])
                        }
                        sx={{
                          cursor: locked ? "not-allowed" : "pointer",
                          position: "relative",
                        }}
                      >
                        <Typography className={styles.ButtonText}>
                          {bettingOptions[index + 1].label}
                        </Typography>
                        <ExposureLabel
                          value={getExposureValue(
                            bettingOptions[index + 1].betType.toUpperCase(),
                          )}
                          outside
                        />

                        {locked && (
                          <Box className={styles.bettinglocked_icon_container}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="21"
                              height="20"
                              viewBox="0 0 21 20"
                              fill="none"
                            >
                              <path
                                d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                                fill="white"
                              />
                            </svg>
                          </Box>
                        )}
                      </Box>
                    </>
                  )}
                </Box>,
              );
            }
            return acc;
          }, [])}
        </Box>

        <Box
          sx={{
            width: "100% !important",
            alignSelf: "stretch",
            marginBottom: "16px",
          }}
        >
          <Typography className={styles.MidTextNo}>12</Typography>
          <Box
            display="flex"
            flexWrap="wrap"
            className={styles.Cards_Section_container}
          >
            {playCardValues.map((value, i) => (
              <Box
                key={i}
                sx={{
                  width: "7%",
                  position: "relative",

                  justifyContent: "center",
                  paddingBottom: "14px",
                  "&:hover": {
                    cursor: locked ? "not-allowed" : "pointer",
                  },
                }}
                className={styles.Cards_container}
                onClick={() => handleCardClick(value.value, value.betType)}
              >
                <Box
                  sx={{
                    alignSelf: "stretch",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "center",
                  }}
                >
                  <Typography className={styles.Cards_number}>
                    {value.value}
                  </Typography>
                </Box>

                <Box className={styles.Cards_icon}>
                  <Box>
                    <Box>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="5"
                        viewBox="0 0 6 5"
                        fill="none"
                      >
                        <path
                          d="M5.03191 2L2.92625 0L0.820592 2C0.294178 2.5 0.294178 3.31429 0.820592 3.81429C1.33949 4.30714 2.16671 4.31429 2.69312 3.84286C2.67056 4.32143 2.49008 4.7 2.17423 5H3.67075C3.3549 4.7 3.17442 4.31429 3.15185 3.84286C3.67827 4.31429 4.51301 4.30714 5.02439 3.81429C5.55832 3.30714 5.55832 2.5 5.03191 2Z"
                          fill="url(#paint0_linear_7156_20672)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_7156_20672"
                            x1="1.39709"
                            y1="1.45157"
                            x2="4.29985"
                            y2="4.50693"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#454545" />
                            <stop offset="1" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Box>
                    <Box>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="5"
                        viewBox="0 0 6 5"
                        fill="none"
                      >
                        <path
                          d="M5.34766 2.5L2.84766 5L0.347656 2.5L2.84766 0L5.34766 2.5Z"
                          fill="url(#paint0_linear_7156_8036)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_7156_8036"
                            x1="1.39016"
                            y1="1.24857"
                            x2="3.86074"
                            y2="4.13092"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FE5B42" />
                            <stop offset="1" stop-color="#BA0000" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Box>
                  </Box>
                  <Box>
                    <Box>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="5"
                        viewBox="0 0 6 5"
                        fill="none"
                      >
                        <path
                          d="M4.181 1.80464C4.11493 1.80464 4.05235 1.81126 3.99324 1.81788C4.11146 1.63576 4.181 1.42053 4.181 1.19205C4.181 0.533113 3.62119 0 2.92926 0C2.23733 0 1.67752 0.533113 1.67752 1.19205C1.67752 1.42384 1.74706 1.63576 1.86528 1.81788C1.80269 1.80795 1.74011 1.80464 1.67752 1.80464C0.985587 1.80464 0.425781 2.33775 0.425781 2.99669C0.425781 3.65563 0.985587 4.18874 1.67752 4.18874C2.10172 4.18874 2.47376 3.98676 2.69977 3.68212C2.71368 4.23179 2.53287 4.66556 2.18169 5H3.66987C3.32217 4.66556 3.14136 4.23179 3.15179 3.68212C3.3778 3.98676 3.74984 4.18874 4.17404 4.18874C4.86598 4.18874 5.42578 3.65563 5.42578 2.99669C5.42578 2.33775 4.86945 1.80464 4.181 1.80464Z"
                          fill="url(#paint0_linear_7156_20675)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_7156_20675"
                            x1="1.25933"
                            y1="1.09901"
                            x2="4.43616"
                            y2="4.43524"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#454545" />
                            <stop offset="1" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Box>
                    <Box>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="5"
                        viewBox="0 0 6 5"
                        fill="none"
                      >
                        <path
                          d="M4.95093 0.45C4.42196 -0.15 3.57184 -0.15 3.04287 0.45L2.84766 0.671428L2.65244 0.45C2.12347 -0.15 1.27335 -0.15 0.744382 0.45C0.215414 1.05 0.215414 2.01429 0.744382 2.61429L2.84766 5L4.95093 2.61429C5.4799 2.01429 5.4799 1.04286 4.95093 0.45Z"
                          fill="url(#paint0_linear_7156_8039)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_7156_8039"
                            x1="1.31888"
                            y1="-0.206643"
                            x2="4.76116"
                            y2="2.82811"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FE5B42" />
                            <stop offset="1" stop-color="#BA0000" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Box>
                  </Box>
                </Box>
                <ExposureLabel value={getExposureValue(value.betType)} small />

                {locked && (
                  <Box className={styles.bettinglocked_icon_container}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                        fill="white"
                      />
                    </svg>
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>

        <FooterLinks
          gameType="AAA"
          socketData={socketData}
          settledData={settledData}
        />
      </Box>
    </Box>
  );
}

export default AmarAkbarAnthony;
